import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Media from 'react-media';

import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import { sortAB, sortBA, sortDate } from 'utils/sortTable';

import {
  Icon,
  TooltipForElement,
  BtnDel
} from 'components/common/Elements/Elements';

import tableGroupsConfig from './helpers/tableGroupsConfig';

import classes from './TableGroupsArticles.module.scss';

const TableGroupsArticles = ({
  dataGropups,
  onClickDel,
  onAlert,
  ofAlert,
  showAllList,
  className
}) => {
  const language = useUserState().user.language;

  const [field, setField] = useState('articlesLen');
  const [direction, setDirection] = useState(-1);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(dataGropups);
  }, [dataGropups]);

  const handleField = checkedField => {
    const cheked = tableGroupsConfig.find(item => item.field === checkedField);

    if (!cheked.isSortable) {
      return;
    }

    if (cheked.field !== field) {
      setField(cheked.field);

      if (cheked.field === 'createdDate') {
        setTableData(
          sortDate(tableData, checkedField, direction, sortAB, cheked.field)
        );
      } else {
        setTableData(sortAB(tableData, checkedField, direction));
      }
    } else if (cheked.field === field) {
      setDirection(direction * -1);

      if (cheked.field === 'createdDate') {
        setTableData(
          sortDate(tableData, checkedField, direction, sortBA, cheked.field)
        );
      } else {
        setTableData(sortBA(tableData, checkedField, direction));
      }
    }
  };

  const TableBody = (group, index) => {
    return (
      <tr className={classes.row} key={group.id}>
        <td className={classes.cell}>
          <span>{index + 1}</span>
        </td>
        <td className={classes.cell}>
          <Link className={classes.wrapTitle} to={`/groups/${group.id}`}>
            <p className={classes.hiddenTextTwo}>{group.title}</p>
            <p>{group.createdDate}</p>
          </Link>
        </td>
        <td className={classes.cell}>
          <div className={classes.wrapHeading}>
            <Link
              className={cn(classes.link, classes.hiddenTextThree)}
              to={`/groups/${group.id}`}
            >
              {group.articleTitle}
            </Link>
          </div>
        </td>
        <td className={classes.cell}>
          <p>{group.articlesLen}</p>
        </td>
        <td className={classes.cell}>
          <p>{group.totalAttendance}</p>
        </td>
        <td className={classes.cell}>
          <p>{group.totalAverageAttendance}</p>
        </td>
        <Media
          queries={{
            small: '(max-width: 1279px)'
          }}
        >
          {matches => (
            <>
              <td className={classes.cell}>
                <TooltipForElement
                  text={
                    !group.hasNewArticlesAlert
                      ? t('tooltip', 'RECEIVE_NOTIF', language)
                      : t('tooltip', 'UNSUBSCRIBE', language)
                  }
                  isOpen={matches.small ? false : undefined}
                >
                  <button
                    type="button"
                    className={classes.subscribeButton}
                    onClick={
                      !group.hasNewArticlesAlert
                        ? () =>
                            onAlert({
                              id: group.id,
                              title: group.articleTitle
                            })
                        : () => {
                            ofAlert(group.alertId);
                          }
                    }
                  >
                    {!group.hasNewArticlesAlert ? (
                      <Icon
                        icon={'Icn_Sub'}
                        className={classes.iconUnSubscribe}
                      />
                    ) : (
                      <Icon
                        icon={'Icn_UnSub'}
                        className={classes.iconUnSubscribe}
                      />
                    )}
                  </button>
                </TooltipForElement>
              </td>

              <td className={classes.cell}>
                <TooltipForElement
                  text={t('tooltip', 'DEL_GROUP', language)}
                  isOpen={matches.small ? false : undefined}
                >
                  <BtnDel
                    onClick={() => onClickDel(group.id)}
                    icon={'Icn_DelNoFill'}
                    classIcon={classes.iconDelNoFill}
                  />
                </TooltipForElement>
              </td>
            </>
          )}
        </Media>
      </tr>
    );
  };

  return (
    <table className={cn(classes.tableGroupsArticles, className)}>
      <thead>
        <tr className={classes.heading}>
          {tableGroupsConfig.map(item => (
            <th className={classes.base} key={item.field}>
              <button
                type="button"
                className={cn(
                  classes.directionButton,
                  item.isSortable && classes.directionButton_isSortable
                )}
                onClick={() => handleField(item.field)}
              >
                {item.field === field && (
                  <Icon
                    icon={'Arrow-sort'}
                    className={cn(
                      classes.iconArrowSort,
                      direction === 1 && classes.transformIcon
                    )}
                  />
                )}
                {t('table', item.name, language)}
              </button>

              {item.info && (
                <TooltipForElement text={t('tooltip', item.info, language)}>
                  <button type="button" className={classes.infoButton}>
                    <Icon
                      icon={'error_outline-24px-2'}
                      className={classes.iconInfo}
                    />
                  </button>
                </TooltipForElement>
              )}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {tableData.map((group, index) =>
          !showAllList
            ? index < 5 && TableBody(group, index)
            : TableBody(group, index)
        )}
      </tbody>
    </table>
  );
};

TableGroupsArticles.propTypes = {
  dataGropups: PropTypes.array,
  onClickDel: PropTypes.func.isRequired,
  onAlert: PropTypes.func.isRequired,
  ofAlert: PropTypes.func.isRequired,
  showAllList: PropTypes.bool,
  className: PropTypes.string
};

export default TableGroupsArticles;
